import React, {Component} from 'react';
import '../../../Home.css';
let _this;

class SigmaSpeaksSupport extends Component {
    constructor(props, context) {
        super(props, context);
        _this = this;

        _this.state = {
            faq: [
                {
                    question: 'Q: What is Sigma Speaks?',
                    answer: 'A: Sigma Speaks is an audio-first, AI-powered financial news app that delivers personalized market updates in real-time, tailored specifically for retail investors. The app is currently in validation state with access available only through TestFlight and Google Play beta programs.'
                },
                {
                    question: 'Q: How can I access Sigma Speaks?',
                    answer: 'A: Sigma Speaks is currently in beta testing phase. You can access it through TestFlight on iOS (https://testflight.apple.com/join/kzNZGq4A) or through Google Play beta program. Alternatively, you can listen to our daily show on Spotify and Apple Podcasts.'
                },
                {
                    question: 'Q: Where can I listen to the Sigma Speaks Show?',
                    answer: 'A: You can listen to our daily podcast "Sigma Speaks Show" featuring top 10 market stories on Apple Podcasts (https://podcasts.apple.com/us/podcast/sigma-speaks/id1851266467) or Spotify (https://open.spotify.com/show/7hz2cM5DfbbTv26ppMbfdR).'
                },
                {
                    question: 'Q: What makes Sigma Speaks different from other financial news apps?',
                    answer: 'A: Sigma Speaks is designed to be an audio-first, hands-free financial news product. Our vision is to deliver personalized market updates based on your portfolio holdings, with high-quality AI narration designed for commutes, workouts, and multitasking. While we\'re still developing the personalization features, the current beta version demonstrates our audio-first approach with AI narration of financial news.'
                },
                {
                    question: 'Q: Is Sigma Speaks free to use?',
                    answer: 'A: Yes, Sigma Speaks is completely free to use during our beta testing phase. As we are currently in the validation state, we are focused on gathering user feedback rather than implementing subscription features. All features available in the app are free for beta users.'
                },
                {
                    question: 'Q: When will Sigma Speaks be fully launched?',
                    answer: 'A: Sigma Speaks is currently in validation state with a working iOS MVP. We are gathering user feedback through our beta programs to improve the product before full launch. Stay tuned for updates!'
                },
                {
                    question: 'Q: Can I customize what news I receive?',
                    answer: 'A: Not yet. The personalization feature that allows you to follow your portfolio holdings and receive portfolio-relevant news first is still in development. This functionality will be a core part of Sigma Speaks, but it\'s not available in the current beta version. We\'re actively working on implementing these features based on user feedback before our full launch.'
                },
                {
                    question: 'Q: How does the audio narration work?',
                    answer: 'A: Sigma Speaks uses advanced AI/TTS (Text-to-Speech) technology to narrate news articles with natural-sounding voices. Our technology has been tested and validated to provide a high-quality listening experience.'
                },
                {
                    question: 'Q: Will I receive notifications for breaking news?',
                    answer: 'A: This feature is planned but not yet fully implemented in the current beta version. In the future, Sigma Speaks will provide push notifications for breaking news on your watched stocks, ensuring you never miss important updates about your investments. We\'re working on implementing this feature based on user feedback during our validation phase.'
                },
                {
                    question: 'Q: How do I provide feedback or request features?',
                    answer: 'A: We strongly encourage all beta users to send us your feedback, feature requests, or report any issues you encounter! Please email us at support@answersolutions.net. Your input is invaluable and directly shapes the development of Sigma Speaks during this validation phase.'
                },
            ]
        };
    }

    componentDidMount() {

    }

    render() {
        return (
            <div className="container">
                <div className="fast_nav container">
                    <ul>
                        <li className="first">
                            <a href="#" role="button"
                               onClick={() => _this.props.navigate('Products')}>2025 © AnswerSolutions LLC</a>
                        </li>
                        <li>
                            <a href="#sigma-speaks-product" role="button"
                               onClick={() => _this.props.navigate('SigmaSpeaksProduct')}>Sigma Speaks</a>
                        </li>
                        <li>
                            <a href="#sigmaspeakspolicy" role="button"
                               onClick={() => _this.props.navigate('SigmaSpeaksPolicy')}>Privacy Policy</a>
                        </li>
                        <li>
                            <a href="#sigmaspeakseula" role="button"
                               onClick={() => _this.props.navigate('SigmaSpeaksEULA')}>User Agreement</a>
                        </li>
                        <li className="selected">
                            <a href="#sigmaspeaksSupport" role="button"
                               onClick={() => _this.props.navigate('SigmaSpeaksSupport')}>Support</a>
                        </li>
                    </ul>
                </div>
                <br/>
                <div>
                    <img style={{borderRadius: '10%'}} className="roundrect" src="/sigma_speaks_artwork.png" align="left"
                         hspace="10" vspace="10" alt="app icon"
                         width="128"/>
                    <br/>
                    <h2>Sigma Speaks: Audio News Daily</h2>
                    <h3>Tailored for Retail Investors</h3>
                </div>
                <br/>
                <br/>
                <div style={{padding: '20px', fontFamily: 'Arial, sans-serif'}}>
                    <div style={{marginBottom: '40px', padding: '20px', backgroundColor: '#f8f9fa', borderRadius: '10px', border: '1px solid #e9ecef'}}>
                        <h2 style={{color: '#0d6efd'}}>Project Status: Validation Phase</h2>
                        <p style={{fontSize: '16px', lineHeight: '1.6'}}>
                            <strong>Sigma Speaks is currently in validation state.</strong> Access is available exclusively through:
                        </p>
                        <ul style={{marginLeft: '20px', marginTop: '10px', marginBottom: '15px'}}>
                            <li style={{marginBottom: '8px'}}>
                                <strong>iOS TestFlight Beta:</strong> <a href="https://testflight.apple.com/join/kzNZGq4A" target="_blank" rel="noopener noreferrer">download from testflight</a>
                            </li>
                            <li style={{marginBottom: '8px'}}>
                                <strong>Google Play Beta Program</strong> <a href="https://play.google.com/apps/testing/com.answersolutions.sigmaspeak" target="_blank" rel="noopener noreferrer">download from google play beta</a>
                            </li>
                        </ul>
                        <p style={{fontSize: '16px', lineHeight: '1.6'}}>
                            Alternatively, you can listen to our daily "Sigma Speaks Show" featuring top market stories on:
                        </p>
                        <ul style={{marginLeft: '20px', marginTop: '10px'}}>
                            <li style={{marginBottom: '8px'}}>
                                <strong>Apple Podcasts:</strong> <a href="https://podcasts.apple.com/us/podcast/sigma-speaks/id1851266467" target="_blank" rel="noopener noreferrer">https://podcasts.apple.com/us/podcast/sigma-speaks/id1851266467</a>
                            </li>
                            <li style={{marginBottom: '8px'}}>
                                <strong>Spotify:</strong> <a href="https://open.spotify.com/show/7hz2cM5DfbbTv26ppMbfdR" target="_blank" rel="noopener noreferrer">https://open.spotify.com/show/7hz2cM5DfbbTv26ppMbfdR</a>
                            </li>
                        </ul>
                        <p style={{fontSize: '16px', lineHeight: '1.6', marginTop: '15px'}}>
                            We appreciate your interest and feedback as we continue to improve the Sigma Speaks experience!
                        </p>
                    </div>

                    <div style={{marginBottom: '40px'}}>
                        <h2>FAQ And Support</h2>
                        {this.state.faq.map((item, index) => (
                            <div key={index} style={{marginBottom: '20px'}}>
                                <h3 style={{marginBottom: '8px'}}>{item.question}</h3>
                                <p>{item.answer}</p>
                                <hr style={{margin: '20px 0'}}/>
                            </div>
                        ))}
                    </div>

                    <div style={{marginBottom: '40px'}}>
                        <h2>Need Help?</h2>
                        <p>We're actively seeking feedback during our validation phase! If you have questions, suggestions, or encounter any issues with the beta version, please contact us via email at support@answersolutions.net.</p>
                        <p style={{marginTop: '10px'}}>Your feedback is invaluable as we continue to improve Sigma Speaks before our full launch.</p>
                    </div>
                    <br/>
                    <br/>
                    <br/>
                    <div className="fast_nav container">
                        <ul>
                            <li className="first">
                                2025 © AnswerSolutions LLC
                            </li>
                            <li>
                                <a href="#Products" role="button"
                                   onClick={() => _this.props.navigate('Products')}>Products</a>
                            </li>
                            <li>
                                <a href="#sigma-speaks-product" role="button"
                                   onClick={() => _this.props.navigate('SigmaSpeaksProduct')}>Sigma Speaks</a>
                            </li>
                            <li>
                                <a href="#sigmaspeakspolicy" role="button"
                                   onClick={() => _this.props.navigate('SigmaSpeaksPolicy')}>Privacy Policy</a>
                            </li>
                            <li>
                                <a href="#sigmaspeakseula" role="button"
                                   onClick={() => _this.props.navigate('SigmaSpeaksEULA')}>User Agreement</a>
                            </li>
                            <li className="selected">
                                <a href="#sigmaspeaksSupport" role="button"
                                   onClick={() => _this.props.navigate('SigmaSpeaksSupport')}>Support</a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        );
    }
}

export default SigmaSpeaksSupport;
